import responseErrorGenerator from 'global/lib/api/responseError'
import routesConfig from 'sen/lib/routes/routesConfig'

export default responseErrorGenerator(routesConfig.SIGNIN_SIGNUP.path)
